import { render, staticRenderFns } from "./ModalBaseBack.vue?vue&type=template&id=3122dcbc&scoped=true&"
var script = {}
import style0 from "./ModalBaseBack.vue?vue&type=style&index=0&id=3122dcbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3122dcbc",
  null
  
)

export default component.exports